<template>
	<div class="app-container">
		<div class="index-tree-box">
			<type-tree ref="type_tree" @on-select="onSelect" @title-click="titleClick" />
			<div class="right-box">
				<list ref="list">
					<template slot="toolbar-right" v-if="$permission.canWrite()">
						<el-button type="success" plain @click="onImprot" v-if="!isMB">导入</el-button>
						<el-button type="success" @click="onExport" v-if="!isMB">导出</el-button>
						<el-button type="primary" :disabled="is_Create"  @click="create" icon="el-icon-plus">添加</el-button>
						<el-button type="danger" @click="delRows">删除</el-button>
					</template>
					<template slot="column" v-if="$permission.canWrite()">
						<el-table-column label="操作" fixed="right" align="center" width="80">
							<template slot-scope="{ row }">
								<el-button type="text" @click="edit(row)">编辑</el-button>
							</template>
						</el-table-column>
					</template>
				</list>
			</div>
		</div>

		<edit-dialog ref="editDialog" @close-saved="reload" />
		<singles-dialog ref="singleDialog" @close-saved="reload" />
		<more-dialog ref="moreDialog" @close-saved="reload" />
		<import-dialog ref="importDialog" @upload-success="reload" />
	</div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/basedata/inventory/unit/list";
import editDialog from "@/components/basedata/inventory/unit/editDialog";
import singlesDialog from "@/components/basedata/inventory/unit/type/singleDialog";
import moreDialog from "@/components/basedata/inventory/unit/type/moreDialog";
import importDialog from "@/components/basedata/inventory/unit/importDialog";
import typeTree from "@/components/basedata/inventory/unit/type/tree";

export default {
	name: "unit",
	mixins: [curdMixins],
	components: {
		list,
		editDialog,
		importDialog,
		typeTree,
		moreDialog,
		singlesDialog
	},
	mounted() { },
	data() {
		return {
			isMB: this.$store.state.isMB,
			isUnitGroup:0,
			select: {
				mode: null,
				UnitGroupId: null,
				UnitId: null,
				UnitName: "",
				Name: "",
			},
		};
	},
	computed:{
		is_Create(){
			return !(this.select.mode == 1 || this.select.mode == 0)
		}
	},
	methods: {
		reload(){
			this.$refs.type_tree.getData();
			this.$refs.list.reload();
		},	
		onSelect(data) {
			this.select.mode = data.mode;
			// 单计量
			if (data.mode == 0) {
				this.isUnitGroup = 0
				this.select.Name = data.UnitName;
				// this.select.UnitId = data.UnitId;
				this.$refs.list.getData({ UnitGroupId: null, IsGroup: false });
			}
			// 多计量
			if (data.mode == 1) {
				this.isUnitGroup = 1
				if(data.children) return this.$refs.list.getData({IsGroup: true });	
				this.select.Name = data.Name;
				this.select.UnitGroupId = data.UnitGroupId;
				this.$refs.list.getData({ UnitGroupId: data.UnitGroupId, IsGroup: true });
			}
			console.log(this.select);
		},
		titleClick() {
			this.select.Id = null;
			this.select.Name = "";
			this.$refs.list.getData({ IdChain: null });
		},
		create() {
			// const params = this.select.mode === 1 ? {  IsGroup: true } : { UnitGroupId: 0, IsGroup: false }
			this.isUnitGroup === 1 ? this.$refs.moreDialog.openCreate() : this.$refs.singleDialog.openCreate();
			
		},
		edit(data){
			let {IsGroup} = data;
			if(IsGroup){
				this.isUnitGroup = 1
			}else{
				this.isUnitGroup = 0
			}
			
			this.isUnitGroup === 1 ? this.$refs.moreDialog.openEdit(data) : this.$refs.singleDialog.openEdit(data);
			
		},
		onImprot() {
			this.$refs.importDialog.open();
		},
		onExport() {
			this.$confirm("是否导出数据？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$refs.list.onExport();
				})
				.catch(() => { });
		},
		delRows() {
			let rows = this.$refs.list.getCheckedRows();
			if (rows.length == 0) {
				this.$message.warning("请选择要删除的数据");
				return;
			}
			this.$confirm("确认删除所选的数据吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					let ids = rows.map((item) => {
						return item.UnitId;
					});
					this.$refs.list.delRange(ids);
				})
				.catch(() => { });
		},
	},
};
</script>